import { IFeature, INavItem, IStep, ITestimonial } from "../interfaces/IHome";
import {
    CalendarToday,
    People,
    PersonAdd,
    Link as LinkIcon,
    AutoAwesome,
    BarChart
} from '@mui/icons-material';
import { paths } from "../routes/paths";

export const navItems: INavItem[] = [
    { label: "Search Events", href: paths.public.searchEvents },
    { label: "Pricing", href: paths.public.betaProgram },
    { label: "Event Organisers", href: paths.public.eventOrganizers },
    { label: "Contact", href: paths.public.contact }
];

export const features: IFeature[] = [
    {
        title: "Smart Attendee Matching",
        description: "AI-powered recommendations connect you with the right people based on professional interests, goals, and industry expertise.",
        icon: AutoAwesome,
        type: "attendee",
        benefits: [
            "Interest-based matching algorithms",
            "Career goal alignment",
            "Industry expertise filtering",
            "Experience level matching",
            "Mutual connection suggestions"
        ]
    },
    {
        title: "QR Ticket Check-in",
        description: "Seamless event entry with QR code scanning for instant ticket validation and real-time attendance tracking.",
        icon: LinkIcon,
        type: "organizer",
        benefits: [
            "Instant ticket validation",
            "Real-time attendance tracking",
            "Contactless check-in",
            "Duplicate ticket prevention",
            "Live event capacity monitoring"
        ]
    },
    {
        title: "Multi-Session Events",
        description: "Create complex events with multiple sessions, workshops, and multi-day schedules with custom session types and roles.",
        icon: CalendarToday,
        type: "organizer",
        benefits: [
            "Multiple sessions per event",
            "Custom session types (Workshop, Keynote, Panel)",
            "Session-specific roles (Speaker, Moderator, Host)",
            "Multi-day event scheduling",
            "Session capacity management"
        ]
    },
    {
        title: "Pre-Event Networking",
        description: "Start building connections before the event with attendee discovery, messaging, and meeting scheduling.",
        icon: People,
        type: "attendee",
        benefits: [
            "Browse attendee profiles before event",
            "Send connection requests in advance",
            "In-app messaging system",
            "Schedule pre-event meetings",
            "See who's attending in real-time"
        ]
    },
    {
        title: "Custom Registration Forms",
        description: "Build tailored registration experiences with fully customizable forms to collect exactly the data you need.",
        icon: PersonAdd,
        type: "organizer",
        benefits: [
            "Drag-and-drop form builder",
            "Custom field types",
            "Conditional logic",
            "Role-based registration",
            "Integration with ticketing"
        ]
    },
    {
        title: "Comprehensive Analytics",
        description: "Track event performance, attendee engagement, and networking activity with detailed insights and data exports.",
        icon: BarChart,
        type: "organizer",
        benefits: [
            "Event performance metrics",
            "Attendee engagement tracking",
            "Connection analytics",
            "Location utilization reports",
            "CSV and Excel data exports"
        ]
    }
];

export const steps: IStep[] = [
    {
        title: "Create Your Event",
        description: "Set up your event with all essential details, customize registration options, and brand the experience.",
        icon: "CalendarToday"
    },
    {
        title: "Invite Attendees",
        description: "Send invitations through various channels and let attendees register through our intuitive platform.",
        icon: "EventAvailable"
    },
    {
        title: "Discover Connections",
        description: "Browse through attendee profiles and discover potential connections based on interests and goals.",
        icon: "Search"
    },
    {
        title: "Connect & Engage",
        description: "Send connection requests, schedule meetings, and prepare for meaningful in-person interactions.",
        icon: "Handshake"
    }
];

export const testimonials: ITestimonial[] = [
    {
        quote: "This platform has transformed how we approach networking at our corporate events. The ability to connect with attendees beforehand has increased our meeting efficiency by 40%.",
        author: "Sarah Johnson",
        role: "Head of Events",
        company: "TechCorp Inc.",
        image: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=300"
    },
    {
        quote: "The personalised engagement features have helped us create more meaningful connections at industry conferences. It's like having a networking assistant in your pocket.",
        author: "Michael Chen",
        role: "Marketing Director",
        company: "Innovate Solutions",
        image: "https://images.pexels.com/photos/3776780/pexels-photo-3776780.jpeg?auto=compress&cs=tinysrgb&w=300"
    },
    {
        quote: "We've seen a 65% increase in valuable connections made at our events since implementing this platform. The ROI has been exceptional.",
        author: "Priya Sharma",
        role: "CEO",
        company: "Global Connect",
        image: "https://images.pexels.com/photos/3772509/pexels-photo-3772509.jpeg?auto=compress&cs=tinysrgb&w=300"
    }
];